import DCSTable from "./Table/index";
import { DCSProvider } from "./Table/DCSContext";
import { Stack, Typography, Select, MenuItem } from "@mui/material";
import StyleIcon from "@mui/icons-material/Style";
import React, { useState } from "react";

export const Types = [
  "MRQ",
  "RFI",
  "Client",
  "Engineering",
  "Project Management",
  "Quality Control",
  "Fabrication",
  "Vendor",
];

export default function DocReviewer({
  projectId,
  plant = false,
  initialType = "Engineering",
  hideTypeSelector = false,
}) {
  const [selectedOption, setSelectedOption] = useState(initialType);
  return (
    <DCSProvider type={selectedOption} plant={plant}>
      <DocReviewerContent
        projectId={projectId}
        plant={plant}
        selectedOption={selectedOption}
        onTypeChange={setSelectedOption}
        hideTypeSelector={hideTypeSelector}
      />
    </DCSProvider>
  );
}

const DocReviewerContent = ({
  projectId,
  plant,
  selectedOption,
  onTypeChange,
  hideTypeSelector = false,
}) => {
  return (
    <>
      {!hideTypeSelector && (
        <Stack spacing={2} paddingBottom={2}>
          <Stack
            direction={"row"}
            spacing={2}
            sx={{ alignItems: "center", flexWrap: "wrap" }}
          >
            <StyleIcon color="secondary" />
            <Typography variant="h5" color="darkBlue">
              Document Type:
            </Typography>
            <Select
              value={selectedOption}
              onChange={(event) => onTypeChange(event.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Select View" }}
              sx={{ width: 160, backgroundColor: "white", height: 40 }}
            >
              {Types.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Stack>
      )}
      <DCSTable
        projectId={projectId || ""}
        type={selectedOption}
        plant={plant}
        projectFilter="all"
      />
    </>
  );
};
